<template>
  <section>
    <TableBox ref="tableBox" />
  </section>
</template>

<script>
import TableBox from './tableBox';
export default {
  components: {
    TableBox,
  },
  methods: {
    getData () {
      this.$refs.tableBox.getData();
    },
  },
  mounted () {
    this.$nextTick(() => {
      this.getData();
    });
  },
};
</script>

<style lang="scss" scoped>
</style>
